<template>
  <TextButton color="secondary" class="font-bold underline underline-offset-4">
    <span v-if="active">
      {{ $t('Cancel') }}
    </span>
    <span v-else>
      {{ $t('Modify') }}
    </span>
  </TextButton>
</template>

<script setup lang="ts">
import TextButton from './TextButton.vue';


defineProps<{
  active: boolean;
}>();

</script>
